module.exports = __webpack_public_path__ + "static/evelyn-bond-social-3fb6ae96ddf823d410f5af14d94b69bb.jpg";